import { EventDocumentMatchResponseType } from '../../models/core/integrations.type';
import { AxiosCustomRequestType } from '../../models/utils/axios.type';
import { call } from '../core.service';

const integrationsEndpoint = '/v1/integrations';

export default class IntegrationsService {
  static readonly eventDocumentMatchGet = async (searchProps: {
    idEmpresa?: string | null;
    idDocumentoTipo: number;
    dataInicial: string;
    dataFinal: string;
    listaCnpjCpf: string[];
  }): Promise<EventDocumentMatchResponseType[]> => {
    const request: AxiosCustomRequestType = {
      method: 'GET',
      url: `${integrationsEndpoint}/documents`,
      params: searchProps,
      timeout: 60000,
    };
    return (await call(request))?.data?.data;
  };
}
